import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';
import { useRouter } from '@/composables/useNuxtRouter';
import { getEntityPermissions } from '@/lib/constants/entityPermissions';
import type { EntityKey } from '@/lib/constants/entityPermissions';
import { useAuth } from '@/composables/useAuth';
import { useNotification } from '@/composables/useNotification';

interface Props {
	/** v-model value */
	value?: any;
	/** Entity key for navigation */
	entity?: EntityKey;
	/** Show clear button */
	clearable?: boolean;
	/** Enable filtering */
	filterable?: boolean;
	/** Loading state */
	loading?: boolean;
	/** Placeholder text */
	placeholder?: string;
	/** Disabled state */
	disabled?: boolean;
	/** Filter method function */
	filterMethod?: (query: string) => void;
	/** Default first option */
	defaultFirstOption?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ElSelectLink',
  props: {
    value: null,
    entity: null,
    clearable: { type: Boolean, default: true },
    filterable: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    placeholder: null,
    disabled: { type: Boolean, default: false },
    filterMethod: null,
    defaultFirstOption: { type: Boolean, default: false }
  },
  emits: ['input', 'change', 'clear'],
  setup(__props: any, { emit }) {

const props = __props as { value?: any, entity?: EntityKey, clearable: boolean, filterable: boolean, loading: boolean, placeholder?: string, disabled: boolean, filterMethod?: (query: string) => void, defaultFirstOption: boolean };





// Composables
const router = useRouter();
const { isInRoles } = useAuth();
const { warning } = useNotification();

// Event handlers
const handleInput = (value: any) => {
	emit('input', value);
};

const handleChange = (value: any) => {
	emit('change', value);
};

const handleClear = () => {
	emit('clear');
};

// Entity configuration
const entityConfig = computed(() => {
	if (!props.entity) {
		return null;
	}
	return getEntityPermissions(props.entity);
});

// Navigation button visibility based on entity permissions
const showNavigationButton = computed(() => {
	if (!entityConfig.value) {
		return false;
	}
	return isInRoles([...entityConfig.value.roles]);
});

// Navigation handler
const navigateToEntity = () => {
	if (!entityConfig.value) {
		warning('Configurazione entità non trovata');
		return;
	}

	// La navigazione è disabilitata solo se non c'è un valore selezionato
	if (!props.value) {
		warning('Seleziona un elemento prima di navigare');
		return;
	}

	try {
		const { path, link } = entityConfig.value;
		const url = `/${path}/${link}/${props.value}`;

		// Apri in nuova finestra/tab
		window.open(url, '_blank');
	} catch (error) {
		warning('Errore durante la navigazione');
	}
};

return { __sfc: true,props, emit, router, isInRoles, warning, handleInput, handleChange, handleClear, entityConfig, showNavigationButton, navigateToEntity }
}

})